import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "play-icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 110 126",
  fill: "currentColor",
  width: "100%",
  height: "100%"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "play-icon-path",
      d: "M91.818 52.587a12 12 0 010 20.826l-73.855 42.3A12 12 0 010 105.3V20.7a12 12 0 0117.964-10.412z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "play"}) } }